import {  useState } from 'react';
import { validateRequired, validateEmail, ErrorMessage } from '../../utlis/function.js';
import CommonLoader from '../common/CommonLoader.jsx';
import { Eye, EyeOff } from 'lucide-react';
import { callApi } from '../../services/ApiServices.js';

const AddPayoutModal = ({
  onClose,
  clubDetail,
  fetchRevenueData
}) => {
  const [amount, setAmount] = useState("");
  const[description, setDescription] = useState("")
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleInputChange = ( value) => {
    if(value?.length > 20){
      return;
    }
    setAmount(value)
  setErrors(null)
  };

  const validateFields = () => {
    const newErrors = {};
    if (!validateRequired(amount)) {
      newErrors.amount = 'Amount is required';
    }else if(amount <= 0){
      newErrors.amount = 'Amount must be greater than zero';
    }else if(amount > Number(clubDetail?.revenue_pending)){
      newErrors.amount = "Amount cannot exceed pending payouts"
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateFields()) return;
  try {
    setIsLoading(true)
    const res = await callApi({
      method: "post",
      url: `admin/payout`,
      data: {
        amount: amount,
        description: description,
        clubId: clubDetail?.club_id
      }
    })
    console.log("payout response", res)
    if(res.status === 201){
      onClose()
      fetchRevenueData(1,10)
    }
  } catch (error) {
    console.log("payout error", error)
  }finally{
    setIsLoading(false)
  }
}
     
  return (
    <div className="fixed inset-0 bg-[#000000b5] flex items-center justify-center z-50">
      <div className="bg-white rounded-[20px] max-w-[500px] w-full mx-4 relative shadow-[0_4px_31.9px_11px_rgba(255,255,255,0.25)] animate-fade-in">
        {isLoading && <CommonLoader fullScreen />}

        <div className="p-8">
          <div className='max-h-[80vh] overflow-y-auto'>
            {/* Title */}
            <h2 className="text-[15px] font-semibold text-black mb-2">Pending payout : <span className="text-[#0A3A44]">${clubDetail?.revenue_pending}</span></h2>  
            
            {/* New password  Field */}
            <div className="mb-5 relative">
              <label className="block text-sm font-medium text-black mb-2">
                Amount <span className="text-red-500">*</span>
              </label>
              <input
                type="number"
                placeholder="Enter amount to payout"
                autoComplete='off'
                value={amount}
                onChange={(e) => handleInputChange(e.target.value)}
                className={`w-full h-[48px] px-4 rounded-full border focus:outline-none transition-colors ${
                  errors?.amount  ? "border-red-500" : "border-[#DADADA]"
                }`}
              />
                <ErrorMessage message={errors?.amount} />
            </div>
              <div className="mb-5 relative">
              <label className="block text-sm font-medium text-black mb-2">
                Description
              </label>
              <input
                type="text"
                placeholder="Enter description to payout"
                autoComplete='off'
                value={description}
                onChange={(e) =>{
                  const value = e.target.value
                  if(value?.length > 100){
                    return;
                  }
                  setDescription(value)}}
                className={`w-full h-[48px] px-4 rounded-full border focus:outline-none transition-colors border-[#DADADA]`}
              />
            </div>
          </div>

          {/* Buttons */}
          <div className="flex gap-4 mt-2">
            <button
              onClick={onClose}
              className="flex-1 h-[52px] rounded-full border border-[#06323A] text-[#06323A] font-medium hover:bg-gray-50 cursor-pointer"
            >
              Cancel
            </button>

            <button
              onClick={handleSave}
              disabled={isLoading}
              className="flex-1 h-[52px] rounded-full bg-[#0A3A44] text-white font-medium hover:opacity-90"
            >
              {isLoading ? "Paying..." : "Mark Paid"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPayoutModal;

